import { Box, TextField, MenuItem, Typography } from '@material-ui/core';
// TODO: replace CurrencyTextField with native MUI TextField??
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import { CustomPhoneField } from '../../../../components/common/custom-phone-field';
import { InputType } from '../../../../constants/input-type';
import useRequestStyles from './request.styles';
import { CountriesAdmitedIPhoneNumber } from '../../../../business/cargo';
import { useForm as useCargoForm, useRequestLang } from './hooks';
import { InputPlacesAutocomplete } from '../../../../components/input-places-autocomplete';
import { useForm, Controller } from 'react-hook-form';

export function Form() {
  const {
    data,
    countryCode,
    stores,
    setClientName,
    setPhoneNumber,
    setDeliveryAddress,
    setDeliveryReferences,
    setTotalValue,
    deliveryAddress,
    handleChangeStore,
    registerOptions,
  } = useCargoForm();
  const {
    store,
    clientName = '',
    phoneNumber,
    deliveryReferences = '',
    totalValue,
  } = data;
  const styles = useRequestStyles();
  const {
    pickupPointLabelText,
    userNameLabelText,
    phoneNumberLabelText,
    deliveryAddressLabelText,
    addressDetailLabelText,
    totalValueLabelText,
    fieldsRequiredText,
  } = useRequestLang();
  const {
    register,
    formState: { errors },
    control,
  } = useForm({ mode: 'all' });

  return (
    <Box
      display='flex'
      flexDirection='column'
      gridGap='0.725rem'
      fontSize='1rem'
    >
      <TextField
        {...register('pickupPoint', registerOptions.pickupPoint)}
        value={store ? store?.id : ''}
        label={pickupPointLabelText}
        variant='outlined'
        onChange={handleChangeStore}
        required
        select
        error={Boolean(errors?.pickupPoint)}
        helperText={errors?.pickupPoint?.message}
      >
        {stores.map(option => (
          <MenuItem key={`s-${option.id}`} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
      {store?.address && (
        <Typography className={styles.addressLabel}>
          {store?.address}
        </Typography>
      )}
      <TextField
        {...register('userName', registerOptions.userName)}
        disabled={false}
        label={userNameLabelText}
        onChange={e => setClientName(e.target.value)}
        type={InputType.TEXT}
        value={clientName}
        variant='outlined'
        required
        error={Boolean(errors?.userName)}
        helperText={errors?.userName?.message}
      />
      <Controller
        name='phoneNumber'
        control={control}
        rules={registerOptions.phoneNumber}
        render={({ field: { onChange } }) => {
          const handleChange = value => {
            onChange(value);
            setPhoneNumber(value);
          };
          return (
            <CustomPhoneField
              placeholder=''
              onlyCountries={CountriesAdmitedIPhoneNumber}
              label={`${phoneNumberLabelText}*`}
              error={Boolean(errors?.phoneNumber)}
              helperText={errors?.phoneNumber?.message}
              country={countryCode}
              value={phoneNumber}
              onChange={handleChange}
            />
          );
        }}
      />
      <Controller
        name='deliveryAddress'
        control={control}
        rules={registerOptions.deliveryAddress}
        render={({
          field: { onChange, onBlur },
          fieldState: { isTouched },
        }) => {
          const handleChange = value => {
            onChange(value);
            setDeliveryAddress(value);
          };
          return (
            <InputPlacesAutocomplete
              defaultValue={deliveryAddress?.completeAddress}
              onChange={handleChange}
              disabled={false}
              label={deliveryAddressLabelText}
              variant='outlined'
              required
              error={Boolean(errors?.deliveryAddress)}
              helperText={errors?.deliveryAddress?.message}
              onBlur={onBlur}
              isTouched={isTouched}
            />
          );
        }}
      />
      <TextField
        {...register('deliveryReferences', registerOptions.deliveryReferences)}
        disabled={false}
        label={addressDetailLabelText}
        onChange={e => setDeliveryReferences(e.target.value)}
        type={InputType.TEXT}
        value={deliveryReferences}
        variant='outlined'
        error={Boolean(errors?.deliveryReferences)}
        helperText={errors?.deliveryReferences?.message}
      />
      <Controller
        name='totalValue'
        control={control}
        rules={registerOptions.totalValue}
        render={({ field: { onChange, onBlur } }) => {
          const handleChange = (_, value) => {
            onChange(value);
            setTotalValue(value);
          };
          return (
            <CurrencyTextField
              label={totalValueLabelText}
              variant='outlined'
              minimumValue={'0'}
              value={totalValue || ''}
              currencySymbol='$'
              outputFormat='number'
              textAlign='left'
              onChange={handleChange}
              required
              error={Boolean(errors?.totalValue)}
              helperText={errors?.totalValue?.message}
              onBlur={onBlur}
            />
          );
        }}
      />
      <Typography className={styles.fieldsRequired}>
        {fieldsRequiredText}
      </Typography>
    </Box>
  );
}
